import { OrderStatus, type OrderType } from "@prisma/client";

import { isDirectShip } from "~/shared/orders/order-type";

type InvoiceReadyOrder = {
  orderNo: string;
  status: OrderStatus;
  type: OrderType;
  shippedAt: Date | null;
  items: Array<{
    productId: string | null;
    lotId: string | null;
    lotConsumption?: { id: string } | null;
  }>;
};

/** Shared by the single-order action and multi-order draft/post checks. */
export function orderInvoiceReadinessBlocker(order: InvoiceReadyOrder): string | null {
  if (order.status === OrderStatus.DRAFT) {
    return `Draft Sales Order ${order.orderNo} must be confirmed before invoicing.`;
  }
  if (order.status === OrderStatus.VOID) {
    return `Voided Sales Order ${order.orderNo} cannot be invoiced.`;
  }
  if (order.status === OrderStatus.COMPLETED) {
    return `Completed Sales Order ${order.orderNo} cannot be invoiced.`;
  }
  if (isDirectShip(order.type) && order.shippedAt === null) {
    return `Direct Ship Sales Order ${order.orderNo} must be shipped before invoicing.`;
  }
  const hasUnreadyProduct = order.items.some(
    item => item.productId !== null && item.lotId === null && (!isDirectShip(order.type) || item.lotConsumption == null),
  );
  if (hasUnreadyProduct) {
    return `Sales Order ${order.orderNo} needs lot readiness for every product item before invoicing.`;
  }
  return null;
}
